export default function openStripeCheckoutWithTags(url) {
  window.dataLayer.push({ 'event': 'begin_checkout' })
  window.open(url);
}